import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api } from "../lib/api";
import ProductCard, { categoryLabel } from "../components/ProductCard";

const KEYS = ["all", "meubles", "bijoux", "artisanat", "decoration", "autres"];

export default function Catalog() {
  const { t } = useTranslation();
  const params = useParams();
  const urlCategory = params.category || "all";
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [active, setActive] = useState(urlCategory);

  useEffect(() => { setActive(urlCategory); }, [urlCategory]);

  useEffect(() => {
    setLoading(true);
    const query = active === "all" ? {} : { category: active };
    api.get("/products", { params: query }).then((r) => setProducts(r.data)).catch(() => setProducts([])).finally(() => setLoading(false));
  }, [active]);

  return (
    <div data-testid="catalog-page" className="pt-32 md:pt-40 pb-24">
      <div className="max-w-[1500px] mx-auto px-6 md:px-12">
        <div className="mb-16">
          <div className="overline mb-5">{t("catalog.overline")}</div>
          <h1 className="font-serif text-5xl md:text-7xl text-[#F5F5F0] leading-[0.95]">
            {active === "all" ? (
              <>{t("catalog.all_title_1")} <em className="text-[#D4AF37] not-italic">{t("catalog.all_title_2")}</em></>
            ) : (
              <>{categoryLabel(active, t)} <em className="text-[#D4AF37] not-italic">{t("catalog.cat_title_suffix")}</em></>
            )}
          </h1>
        </div>

        <div className="flex flex-wrap gap-x-8 gap-y-4 mb-16 border-b border-white/10 pb-6">
          {KEYS.map((c) => (
            <button
              key={c}
              data-testid={`filter-${c}`}
              onClick={() => setActive(c)}
              className={`text-xs uppercase tracking-[0.2em] transition-colors pb-1 ${
                active === c ? "text-[#D4AF37] border-b border-[#D4AF37]" : "text-[#A3A39D] hover:text-[#F5F5F0]"
              }`}
            >
              {t(`catalog.filters.${c}`)}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="text-[#A3A39D] text-sm">{t("catalog.loading")}</div>
        ) : products.length === 0 ? (
          <div className="text-[#A3A39D] text-sm">{t("catalog.empty")}</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-14">
            {products.map((p, i) => (<ProductCard key={p.id} product={p} index={i} />))}
          </div>
        )}
      </div>
    </div>
  );
}
